// NOTE :: Import order here is load-bearing (module evaluation order). Re-sorting it with the
// lint auto-fix throws "Cannot access 'ms' before initialization" at boot. Leave it as is.
import ConfirmationService from 'primevue/confirmationservice';
import Pinia from './pinia';
import PrimeVue from 'primevue/config';
import i18n from './i18n';
import router from './router';
import { axios } from './axios';
import { resetAllStores } from './pinia';
import startAssetPinning from './skewProtection';

export default [i18n, Pinia, PrimeVue, router, ConfirmationService];
export { axios, resetAllStores, startAssetPinning };
